import { AvatarIcon } from 'components/Icon/icons/avatar'
import { URL_REGEX } from 'constants/url'
import { ARTICLE_MODEL_CLASS_NAME } from 'models/daos/article/constants'
import {
  COMMENT_HTML_ANCHOR_PREFIX,
  COMMENT_MODEL_CLASS_NAME
} from 'models/daos/comment/constants'
import { MOTIVATION_MODEL_CLASS_NAME } from 'models/daos/motivation/constants'
import { USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'
import { getWebsiteUrlEnvironmentUtil } from 'modules/environment/utils'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import { getRelativeUrlReduxUtil } from 'modules/redux/utils/get-url'
import { isInLengthRangeValidatorUtil } from 'modules/redux/validators/legacy'
import { getObjectUtil } from 'packages/src'

/**
 * Anchor character.
 * Used to navigate to a certain tag of the page.
 * @type {string}
 */
const ANCHOR = '#'

/**
 * Gets the anchor using the given `prefix` and `value`.
 * @param  {string} prefix
 * @param  {String|Number} value
 * @returns {string}
 */
function getAnchorCommentUtil (prefix, value) {
  return `${ANCHOR}${prefix}${value}`
}

const VALIDATOR = {
  value: valueCommentUtil
}

function getValidatorCommentUtil (name) {
  return VALIDATOR[name]
}

/**
 * Validates the comment's value.
 * @param  {string} val
 * @returns {Boolean|String}
 */
function valueCommentUtil (val) {
  // Validate the length of the comment
  const validation = isInLengthRangeValidatorUtil(
    'value', val, COMMENT_MODEL_CLASS_NAME
  )
  if (validation !== true) {
    return validation
  }
  // Get urls that are not from the Gymaholic domain
  const notGymaholicUrl = val
    .split(URL_REGEX.ANY_URL)
    .find((chunk, index) => {
      if (index % 2 === 1) {
        return !chunk.includes(getWebsiteUrlEnvironmentUtil())
      }
      return false
    })
  // If it doesn't belong to the Gymaholic domain,
  // return an error message
  if (notGymaholicUrl) {
    return 'Your comment should not contain any url.'
  }
  return true
}

/**
 * Gets the `Notification`'s content.
 * @param  {Notification} notification
 * @param  {Instance[]} associatedInstances
 * @returns {Object}
 */
function getReplyNotificationCommentUtil (notification, associatedInstances = []) {
  const comment = associatedInstances.find(
    a => a.data.className === COMMENT_MODEL_CLASS_NAME
  )
  const user = associatedInstances.find(
    a => a.data.className === USER_MODEL_CLASS_NAME
  )
  const articleOrMotivation = associatedInstances.find(
    a => [
      ARTICLE_MODEL_CLASS_NAME,
      MOTIVATION_MODEL_CLASS_NAME
    ].includes(a.data.className)
  )
  const comments = getObjectUtil(comment, 'data.comments') || []
  const textBold = `${user.data.name}`
  const instanceLabel = comments.length
    ? articleOrMotivation.className.toLowerCase()
    : 'comment'
  const text = ` replied to your ${instanceLabel}.`
  const image = user.data.avatarThumbnail || user.data.avatar
  const imageUrl = getRelativeUrlReduxUtil(user)
  const icon = image ? null : AvatarIcon
  const image2 = articleOrMotivation.data.img
  let image2Url = getRelativeUrlReduxUtil(articleOrMotivation)
  const anchor = getHtmlAnchorCommentUtil(comment)
  image2Url += anchor
  const textUrl = image2Url
  return {
    icon,
    image,
    imageUrl,
    image2,
    image2Url,
    text,
    textUrl,
    textBold
  }
}

/**
 * Gets the `Notification`'s content.
 * @param  {Notification} notification
 * @param  {Instance[]} associatedInstances
 * @returns {Object}
 */
function getMentionNotificationCommentUtil (notification, associatedInstances = []) {
  const comment = associatedInstances.find(
    a => a.data.className === COMMENT_MODEL_CLASS_NAME
  )
  const user = associatedInstances.find(
    a => a.data.className === USER_MODEL_CLASS_NAME
  )
  const articleOrMotivation = associatedInstances.find(
    a => [
      ARTICLE_MODEL_CLASS_NAME,
      MOTIVATION_MODEL_CLASS_NAME
    ].includes(a.data.className)
  )
  const textBold = `${user.data.name}`
  const text = ' mentioned you in a comment.'
  const image = user.data.avatarThumbnail || user.data.avatar
  const imageUrl = getRelativeUrlReduxUtil(user)
  const icon = image ? null : AvatarIcon
  const image2 = articleOrMotivation.data.img
  let image2Url = getRelativeUrlReduxUtil(articleOrMotivation)
  const anchor = getHtmlAnchorCommentUtil(comment)
  image2Url += anchor
  const textUrl = image2Url
  return {
    icon,
    image,
    imageUrl,
    image2,
    image2Url,
    text,
    textUrl,
    textBold
  }
}

/**
 * Gets the html anchor of the given `Comment`.
 * @param  {Comment} comment
 * @returns {string}
 */
function getHtmlAnchorCommentUtil (comment) {
  const id = getIdReduxUtil(comment)
  return getAnchorCommentUtil(COMMENT_HTML_ANCHOR_PREFIX, id)
}

/**
 * Gets the html anchor of the given `Comment`.
 * @param  {Comment} comment
 * @returns {string}
 */
function getHtmlIdCommentUtil (comment) {
  return getHtmlAnchorCommentUtil(comment).slice(1)
}

export {
  getValidatorCommentUtil,
  getReplyNotificationCommentUtil,
  getMentionNotificationCommentUtil,
  getHtmlAnchorCommentUtil,
  getHtmlIdCommentUtil
}
